import { jsx, jsxs } from "react/jsx-runtime";
import Col from "../Grid/Col.js";
import classnames from "../../utils/classnames.js";
import "react";
import Row from "../Grid/Row.js";
import './DealerInfo.css';import '../Grid/Grid.css';/* empty css                */
import Icon from "../Icon/Icon.js";
import Typography from "../Typography/Typography.js";
import DealerDetails from "../DealerDetails/DealerDetails.js";
/* empty css                */
const DealerInfoTitle = ({ name, location, address, tags, brand, className }) => {
  return /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-dealer-info-title", className), children: /* @__PURE__ */ jsxs(Row, { gutter: [0, "vertical-green"], children: [
    /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsxs(Row, { gutter: [0, "vertical-purple"], children: [
      /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsx(Typography.Title, { headingLevel: 3, color: "darkest", className: classnames("perxis-auto-dealer-info-title__name"), children: name }) }),
      !!location && /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsx(
        Typography.Text,
        {
          level: "main",
          color: "dark-light",
          className: classnames("perxis-auto-dealer-info-title__location"),
          children: location
        }
      ) })
    ] }) }),
    !!brand && /* @__PURE__ */ jsx(Col, { span: 24, className: classnames("perxis-auto-dealer-info-title__brand"), children: brand.image ? /* @__PURE__ */ jsx("img", { src: brand.image, alt: brand.name, className: classnames("perxis-auto-dealer-info-title__brand-image") }) : /* @__PURE__ */ jsx(
      Typography.Paragraph,
      {
        level: "main",
        color: "darkest",
        className: classnames("perxis-auto-dealer-info-title__brand-name"),
        children: brand.name
      }
    ) }),
    !!(tags == null ? void 0 : tags.length) && /* @__PURE__ */ jsx(Col, { span: 24, className: classnames("perxis-auto-dealer-info-title__tag-list"), children: tags.map((tag) => /* @__PURE__ */ jsx(
      DealerDetails,
      {
        tooltipTitle: tag.description,
        icon: !!tag.icon && /* @__PURE__ */ jsx(Icon, { name: tag.icon, sticker: "dealer-info-title-tag-icon" }),
        iconPosition: tag.iconPosition,
        iconColor: tag.iconColor,
        iconHoverColor: tag.iconHoverColor,
        color: tag.color,
        borderColor: tag.borderColor,
        backgroundColor: tag.backgroundColor,
        borderHoverColor: tag.borderHoverColor,
        children: tag.name,
        className: classnames("perxis-auto-dealer-info-title__tag")
      },
      tag.id
    )) }),
    !!address && /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsx(Typography.Text, { level: "main", color: "dark", className: classnames("perxis-auto-dealer-info-title__address"), children: address }) })
  ] }) });
};
export {
  DealerInfoTitle as default
};
//# sourceMappingURL=DealerInfoTitle.js.map
